(() => {
  if (window.AlpenFeinBackInStockInitialized) return;
  window.AlpenFeinBackInStockInitialized = true;

  const COMPANY_ID = 'UTtNmd';
  const REVISION = '2026-07-15';
  const API_ROOT = 'https://a.klaviyo.com/client';
  const requests = new WeakMap();
  const openers = new WeakMap();

  const parseVariants = (widget) => {
    try {
      return JSON.parse(widget.querySelector('[data-bis-variants]')?.textContent || '[]');
    } catch (_) {
      return [];
    }
  };

  const selectedVariantId = (widget) => {
    if (widget.hasAttribute('data-bis-card-host')) return widget.dataset.variantId || '';
    const sectionId = widget.dataset.sectionId;
    const scope = widget.closest('product-info') || document;
    const input = scope.querySelector(`#product-form-${CSS.escape(sectionId)} [name="id"]`)
      || scope.querySelector('form[action*="/cart/add"] [name="id"]');
    return String(input?.value || widget.dataset.variantId || '');
  };

  const syncWidget = (widget) => {
    if (!widget || widget.hasAttribute('data-bis-card-host')) return;
    const variantId = selectedVariantId(widget);
    const variants = parseVariants(widget);
    const variant = variants.find((item) => String(item.id) === variantId);
    if (!variant) return;
    widget.dataset.variantId = variantId;
    const isSoldOut = !variant.available;
    const allVariantsSoldOut = variants.length > 0 && variants.every((item) => !item.available);
    const openButton = widget.querySelector('[data-bis-open]');
    const buyButtonsBlock = widget.closest('.product__block--buy_buttons');
    const productInfo = widget.closest('.product__info-container');
    widget.hidden = !isSoldOut;
    if (openButton) openButton.hidden = !isSoldOut;
    if (buyButtonsBlock) buyButtonsBlock.classList.toggle('alpenfein-bis-selected-soldout', isSoldOut);
    if (productInfo) productInfo.classList.toggle('alpenfein-bis-all-soldout', allVariantsSoldOut);
    if (!isSoldOut) closeModal(widget);
  };

  const syncAll = () => document.querySelectorAll('[data-alpenfein-bis]').forEach(syncWidget);

  const openModal = (widget) => {
    const modal = widget.querySelector('[data-bis-modal]');
    if (!modal) return;
    openers.set(widget, document.activeElement);
    modal.hidden = false;
    document.body.classList.add('alpenfein-bis-open');
    window.setTimeout(() => widget.querySelector('input[type="email"]')?.focus(), 0);
  };

  function closeModal(widget) {
    const modal = widget?.querySelector('[data-bis-modal]');
    if (modal) modal.hidden = true;
    if (!document.querySelector('[data-bis-modal]:not([hidden])')) {
      document.body.classList.remove('alpenfein-bis-open');
    }
    const opener = openers.get(widget);
    if (opener?.isConnected) opener.focus({ preventScroll: true });
    openers.delete(widget);
  }

  const openCardModal = (button) => {
    const widget = document.querySelector('[data-bis-card-host]');
    if (!widget) return;
    let variants;
    try {
      variants = JSON.parse(button.dataset.bisCardVariants).filter((variant) => !variant.available);
    } catch (_) {
      return;
    }
    if (!variants.length) return;
    document.querySelectorAll('[data-bis-modal]:not([hidden])').forEach((modal) => {
      closeModal(modal.closest('[data-alpenfein-bis]'));
    });
    requests.set(widget, {});
    widget.dataset.variantId = String(variants[0].id);
    widget.querySelector('[data-bis-product-title]').textContent = button.dataset.bisCardTitle;
    const select = widget.querySelector('[data-bis-variant-select]');
    select.replaceChildren(...variants.map((variant) => {
      const option = document.createElement('option');
      option.value = String(variant.id);
      option.textContent = variant.title;
      return option;
    }));
    select.disabled = false;
    widget.querySelector('[data-bis-variant-field]').hidden = variants.length < 2;
    const form = widget.querySelector('[data-bis-form]');
    form.reset();
    form.querySelector('button[type="submit"]').disabled = false;
    const message = form.querySelector('[data-bis-message]');
    message.textContent = '';
    message.classList.remove('alpenfein-bis__message--error');
    widget.querySelector('[data-bis-content]').hidden = false;
    widget.querySelector('[data-bis-success]').hidden = true;
    openModal(widget);
  };

  const postJson = async (url, payload) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: REVISION,
      },
      body: JSON.stringify(payload),
      credentials: 'omit',
    });
    if (!response.ok) throw new Error(`Klaviyo returned ${response.status}`);
  };

  const saveLanguage = async (email, locale, language) => {
    await postJson(`${API_ROOT}/profiles/?company_id=${encodeURIComponent(COMPANY_ID)}`, {
      data: {
        type: 'profile',
        attributes: {
          email,
          locale,
          properties: {
            Back_in_Stock_Language: language,
            Back_in_Stock_Source: 'Shopify AlpenFein',
          },
        },
      },
    });
  };

  const subscribeToBackInStock = async (email, variantId) => {
    await postJson(`${API_ROOT}/back-in-stock-subscriptions/?company_id=${encodeURIComponent(COMPANY_ID)}`, {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: { type: 'profile', attributes: { email } },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    });
  };

  document.addEventListener('click', (event) => {
    const cardOpen = event.target.closest('[data-bis-card-open]');
    if (cardOpen) {
      event.preventDefault();
      openCardModal(cardOpen);
      return;
    }
    const open = event.target.closest('[data-bis-open]');
    if (open) {
      const widget = open.closest('[data-alpenfein-bis]');
      syncWidget(widget);
      if (!open.hidden) openModal(widget);
      return;
    }
    const close = event.target.closest('[data-bis-close]');
    if (close) closeModal(close.closest('[data-alpenfein-bis]'));
    const overlay = event.target.matches('[data-bis-modal]') ? event.target : null;
    if (overlay) closeModal(overlay.closest('[data-alpenfein-bis]'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
      const modal = document.querySelector('[data-bis-modal]:not([hidden])');
      if (modal) {
        const elements = [...modal.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), a[href]')]
          .filter((element) => element.getClientRects().length > 0);
        const first = elements[0];
        const last = elements[elements.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }
    }
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-bis-modal]:not([hidden])').forEach((modal) => {
        closeModal(modal.closest('[data-alpenfein-bis]'));
      });
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-bis-variant-select]')) {
      event.target.closest('[data-alpenfein-bis]').dataset.variantId = event.target.value;
    }
    if (event.target.closest('product-info')) window.setTimeout(syncAll, 50);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-bis-form]');
    if (!form) return;
    event.preventDefault();
    const widget = form.closest('[data-alpenfein-bis]');
    const emailInput = form.querySelector('input[type="email"]');
    const message = form.querySelector('[data-bis-message]');
    const submit = form.querySelector('button[type="submit"]');
    if (submit.disabled) return;
    const email = emailInput.value.trim().toLowerCase();
    const language = widget.dataset.language || 'DE';
    const locale = widget.dataset.locale || 'de-DE';
    const variantId = selectedVariantId(widget);
    const invalidText = language === 'IT' ? 'Inserisci un indirizzo email valido.' : 'Bitte gib eine gültige E-Mail-Adresse ein.';
    const errorText = language === 'IT' ? 'Si è verificato un errore. Riprova.' : 'Das hat leider nicht geklappt. Bitte versuche es erneut.';

    if (!emailInput.checkValidity() || !email || !variantId) {
      message.textContent = invalidText;
      message.classList.add('alpenfein-bis__message--error');
      emailInput.focus();
      return;
    }

    submit.disabled = true;
    const request = {};
    requests.set(widget, request);
    const variantSelect = form.querySelector('[data-bis-variant-select]');
    if (variantSelect) variantSelect.disabled = true;
    message.textContent = '';
    message.classList.remove('alpenfein-bis__message--error');
    try {
      try {
        await saveLanguage(email, locale, language);
      } catch (_) {
        // The restock subscription is the critical request; do not block it if profile enrichment fails.
      }
      await subscribeToBackInStock(email, variantId);
      if (requests.get(widget) !== request) return;
      widget.querySelector('[data-bis-content]').hidden = true;
      widget.querySelector('[data-bis-success]').hidden = false;
    } catch (_) {
      if (requests.get(widget) !== request) return;
      message.textContent = errorText;
      message.classList.add('alpenfein-bis__message--error');
      submit.disabled = false;
      if (variantSelect) variantSelect.disabled = false;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }
})();
